import Gawd from 'web/lib/gawd'
import useWalletTokens from './useWalletTokens'

const useMyGawds = (): Gawd[] => {
  const ownedTokens = useWalletTokens()
  // Just maps tokewns to empty Gawd objects. Views are responsible for loading the Gawd
  return ownedTokens.map(t => new Gawd({ id: t.id }))
}

export default useMyGawds;